import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { deleteServers } from '../../../stores/servers/actionCreators';
import { getServerName } from '../../../stores/servers/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    getName: (id: string) => string;
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];

    deleteServers: (ids: string[]) => void;
}
interface State {
    showModal: boolean;
}

class DeleteServersAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="danger"
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'trash']} />
                        {t('servers.button.delete')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('servers.modal.delete.header') as string}
                        confirmText={t('servers.modal.delete.delete') as string}
                        buttonColor="danger"
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.props.deleteServers(this.props.selected);
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('servers.modal.delete.text') as string} <b>{this.getHandle()}</b>?
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private getHandle = () => {
        const t = this.props.translate;
        if (this.props.selected.length !== 1) {
            return t(
                'servers.modal.delete.servers',
                { number: this.props.selected.length }
            );
        } else {
            return this.props.getName(this.props.selected[0]);
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    getName: getServerName(state),
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'servers'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    deleteServers: (ids: string[]) => dispatch(deleteServers(ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(DeleteServersAction));